import React, { useState, useEffect } from 'react'
import { Form, Input, InputNumber, Button, Select, Checkbox, Upload, Tooltip, message, Result } from 'antd';
import { Link, useLocation, useParams } from 'react-router-dom';
import { UploadOutlined } from '@ant-design/icons';

const layout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 12,
    },
};

  /* eslint-disable no-template-curly-in-string */
  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };
  /* eslint-enable no-template-curly-in-string */

  const services = [
    { label: 'Proofreading Works of Fiction', value: 'fiction' },
    { label: 'Proofreading of Thesis/ Dissertation/ Essay', value: 'thesis' },
    { label: 'Proof Listen to Audiobook', value: 'audiobook' },
    { label: 'Audiobook Narration for Picture Books', value: 'narration' },
    { label: 'Writer\'s dilemma', value: 'dilemma' },
    { label: 'Writing your Blurb', value: 'blurb' },
    { label: 'Back-cover review', value: 'review' },
  ];


function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

function getPriceByType(prices, type) {
    let currentPrice = prices.filter(prices => prices['type'] === type);

    if (currentPrice.length > 0) {
        return currentPrice[0]['amount'];
    }

    return 0;
}

export default function Request(props) {
    const [form] = Form.useForm();
    const [price, setPrice] = useState(0);
    const [days, setDays] = useState(1);
    const [showFailed, setShowFailed] = useState(false);
    const [prices, setPrices] = useState(false);
    const [couponError, setCouponError] = useState(false);
    const [couponCode, setCouponCode] = useState(false);
    const [validatingCode, setValidatingCode] = useState(false);
    const [recheckCode, setRecheckCode] = useState(false);

    let query = useQuery();
    let { type } = useParams();

    useEffect(() => {
        document.title = "Vabis' Literature Services - Literature Proofreading - Submit a request";
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        fetch('/api/latest', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(response =>
            response.json()
        ).then(data => {
            if (data.success) {
                setPrices(data.payload);
            } else {
                setPrices(false);
            }
        }).catch((error) => {
            setPrices(false);
        });
    }, []);

    const onFinish = (values) => {
        fetch('/api/submit', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: btoa(JSON.stringify(values))
        }).then(response =>
            response.json()
        ).then(data => {
            if (data.success) {
                window.location.href = data.url;
            } else {
                setShowFailed(true);
            }
        }).catch((error) => {
            setShowFailed(true);
        });
    };

    let service = query.get("service")

    useEffect(() => {
        if (prices && prices['prices']) {
            switch (service) {
                case 'audiobook':
                    setDays(10);
                    setPrice(getPriceByType(prices['prices'],'audiobook'));
                    break;
                case 'narration':
                    setDays(2);
                    setPrice(getPriceByType(prices['prices'],'narration'));
                    break;
                case 'review':
                    setDays(6);
                    setPrice(getPriceByType(prices['prices'],'review'));
                    break;
                default:
            }
        }
    }, [service, prices])

    useEffect(() => {
        form.setFieldsValue({
            'price': price,
            'days': days
        })
    }, [form, price, days])

    /*useEffect(() => {
        setRecheckCode(true)
        if (couponCode) {
            updateCoupon(form.getFieldValue('coupon_code'))
        }
    }, [price])*/

    const calculateDays = (words) => {
        if (!prices) {
            return
        }

        let initDays  = prices['days'];
        let daysToSet = false;

        initDays.forEach(days => {
            if (!daysToSet && words <= days['words']) {
                daysToSet = days['days'];
            }
        });

        setDays(daysToSet);
    }

    const calculateIncrementalPrice = (words, service) => {
        let priceIncrement = getPriceByType(prices['prices'], service + '_1000');
        let price = 0;

        for (let inc = 1000; inc < words; inc+=1000) {
            if (getPriceByType(prices['prices'], service + '_' + inc)) {
                priceIncrement = getPriceByType(prices['prices'], service + '_' + inc);
            }

            if (inc < 10000) {
                continue;
            }

            price += priceIncrement;
        }

        if (price === 0) {
            price = priceIncrement;
        }

        price = Math.round(price * 100) / 100
        setPrice(price);
    }

    const calculateTieredPrice = (words, service) => {
        let price = getPriceByType(prices['prices'], service + '_1000');

        for (let inc = 1000; inc <= words; inc+=1000) {
            if (getPriceByType(prices['prices'], service + '_' + inc)) {
                price = getPriceByType(prices['prices'], service + '_' + inc);
            }
        }

        price = Math.round(price * 100) / 100
        setPrice(price);

        return price
    }

    const updateCoupon = (e = false) => {
        let code = e?.target && e?.target.value;
        setValidatingCode(true);

        if (!code) {
            code = e
        }

        if (couponCode && !recheckCode) {
            setValidatingCode(false);
            return
        }

        setRecheckCode(false);

        if (!code) {
            setCouponCode(false);
            setCouponError(true);
            setValidatingCode(false);
            return;
        }

        let service = form.getFieldValue('service')

        let params = {
            'code': code,
            'service': service
        };

        let query = Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&');

        fetch('/api/coupon?' + query, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(response =>
            response.json()
        ).then(data => {
            if (data.success) {
                setCouponCode(code);
                setCouponError(false)
                setValidatingCode(false)

                if (data.type === 'percent') {
                    setPrice(Math.round((price * (100 - data.amount)) / 100))
                } else if (data.type === 'amount') {
                    setPrice(Math.round((price - data.amount) * 100) / 100)
                }
            } else {
                setCouponCode(false)
                setCouponError(true)
                setValidatingCode(false)
            }
        }).catch((error) => {
            setCouponCode(false)
            setCouponError(false)
            setValidatingCode(false)
        });
    }

    const updatePrice = (e = false) => {
        let service = form.getFieldValue('service')
        let words = 0
        let inc = 1

        if (!prices) {
            return;
        }

        let initPrice = getPriceByType(prices['prices'], service);

        switch (service) {
            case 'fiction':
                words = form.getFieldValue('words')

                if (words === 0) words = 1
                inc = Math.ceil(words/1000)

                initPrice = Math.round(initPrice * inc * 100) / 100
                setPrice(initPrice)
                calculateDays(words)
                break;
            case 'thesis':
                words = form.getFieldValue('words')

                if (words === 0) words = 1
                inc = Math.ceil(words/1000)

                initPrice = Math.round(initPrice * inc * 100) / 100
                setPrice(initPrice)
                calculateDays(words)
                break;
            case 'dilemma':
                let dilemma = form.getFieldValue('dilemma')
                words = form.getFieldValue('words')
                if (words === 0) words = 1

                if (typeof (dilemma) === 'undefined') {
                    dilemma = []
                }

                //let price = 0;
                let options = [];

                prices['prices'].forEach(priceItem =>  {
                    /*price +=
                        (   // XOR
                            (dilemma.includes(priceItem['type']) || (e && e.target && e.target.value === priceItem['type']))
                            && !(dilemma.includes(priceItem['type']) && (e && e.target && e.target.value === priceItem['type']))
                        ) ? priceItem['amount'] : 0
                    */
                    // XOR
                    if ((dilemma.includes(priceItem['type']) || (e && e.target && e.target.value === priceItem['type']))
                        && !(dilemma.includes(priceItem['type']) && (e && e.target && e.target.value === priceItem['type']))
                    ) {
                        options.push(priceItem['amount']);
                    }
                });

                //if (price === 0 || options === 0) {
                if (options.length === 0) {
                    return;
                }

                let unique = [...new Set(options)];
                let dilemmaPrice = 0

                if (unique.length === 1) {
                    dilemmaPrice += unique[0] * (options.length - 1)
                } else if (unique.length === 2) {
                    dilemmaPrice += Math.min(...options) * (options.filter((v) => (v === Math.min(...options))).length - 1)
                    dilemmaPrice += Math.max(...options) *  options.filter((v) => (v === Math.max(...options))).length
                }
                debugger

                let price = calculateTieredPrice(words, service)
                setPrice(Math.round((price + dilemmaPrice) * 100) / 100)
                setDays(6)
            break;
            case 'review':
                setDays(6);
                setPrice(initPrice);
            break;
            case 'blurb':
                words = form.getFieldValue('words')
                if (words === 0) words = 1

                calculateTieredPrice(words, service)
                setDays(6);
            break;
            case 'audiobook':
                words = form.getFieldValue('words')

                setDays(10);

                if (words === 0) words = 1

                inc = Math.ceil(words/1000)

                initPrice = Math.round(initPrice * inc * 100) / 100
                setPrice(initPrice)
            break;
            case 'narration':
                setDays(2);
                setPrice(initPrice);
            break;
            default:
        }
    }

    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    if (type === 'success') {
        return (<Result
            status="success"
            title="Request was successfully submitted"
            subTitle={`Thank you. Your document will be emailed to you.`}
        />)
    } else if (type === 'cancel') {
        return (<Result
            status="warning"
            title="There are some problems with submitting the request."
            subTitle={'If this happens repeatably, let us know by the email to help you.'}
        />)
    }

    return (
        <div className="App">
            <div className="checkout">
                {prices && !showFailed && <Form {...layout} form={form} name="nest-messages" onFinish={onFinish} validateMessages={validateMessages} scrollToFirstError={true}> {/* onValuesChange */}
                    <Form.Item
                        name='name' label="Name"
                        rules={[ {required: true}, ]}>
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name='email' label="Email"
                        rules={[ {required: true}, {type: 'email',}, ]}>
                        <Input />
                    </Form.Item>

                    <Form.Item name="service" label="What service?" initialValue={query.get("service")}
                        rules={[{ required: true, message: 'Missing service' }]}>
                        <Select options={services} onChange={updatePrice} />
                    </Form.Item>

                    <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.service !== currentValues.service}>
                        {({ getFieldValue }) => ['dilemma'].includes(getFieldValue('service')) ? (
                            <Form.Item name="dilemma" label="Checking for" rules={[{ required: true, message: 'Required to resolve the dilemma' }]}>
                                <Checkbox.Group style={{ marginLeft: '0px'}}>
                                    <Checkbox value="sentence" style={{ lineHeight: '32px' }} onChange={updatePrice}>
                                        Dilemma between which word/ phrase is more suitable in a sentence
                                    </Checkbox>
                                    <Checkbox value="names" style={{ lineHeight: '32px' }} onChange={updatePrice}>
                                        Are the names of the characters appropriate
                                    </Checkbox>
                                    <Checkbox value="chapter" style={{ lineHeight: '32px' }} onChange={updatePrice}>
                                        Is the chapter title appropriate
                                    </Checkbox>
                                    <Checkbox value="title" style={{ lineHeight: '32px' }} onChange={updatePrice}>
                                        Is the title of the book good enough
                                    </Checkbox>
                                    <Checkbox value="character" style={{ lineHeight: '32px' }} onChange={updatePrice}>
                                        Character development
                                    </Checkbox>
                                    <Checkbox value="plot" style={{ lineHeight: '32px' }} onChange={updatePrice}>
                                        Plot development
                                    </Checkbox>
                                    <Checkbox value="chapter_title_write" style={{ lineHeight: '32px' }} onChange={updatePrice}>
                                        Write a chapter title
                                    </Checkbox>
                                    <Checkbox value="book_title_write" style={{ lineHeight: '32px' }} onChange={updatePrice}>
                                        Write a book title
                                    </Checkbox>
                                </Checkbox.Group>
                            </Form.Item>
                        ) : null}
                    </Form.Item>

                    <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.service !== currentValues.service}>
                        {({ getFieldValue }) => ['dilemma'].includes(getFieldValue('service')) ? (
                            <Form.Item name='information' label="Enter more details about the dilemma">
                                <Input.TextArea showCount maxLength={250} />
                            </Form.Item>
                        ) : null}
                    </Form.Item>

                    <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.service !== currentValues.service}>
                        {({ getFieldValue }) => ['fiction', 'thesis', 'audiobook', 'blurb', 'dilemma'].includes(getFieldValue('service')) ? (
                            <Form.Item
                                name='words' label="Number of words"
                                rules={[ {required: true}, {type: 'number',min: 0,max: 200000,}, ]}>
                                <InputNumber onChange={updatePrice}/>
                            </Form.Item>
                        ) : null}
                    </Form.Item>

                    <Form.Item name='judiciary' label={true} valuePropName="checked" rules={[ { validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('This is a required field.')),}, ]}>
                        <Checkbox>This contract/ work is bound only by the UK judiciary and law.</Checkbox>
                    </Form.Item>

                    <Form.Item name='policy' label={true} valuePropName="checked" rules={[ { validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('This is a required field.')),}, ]}>
                        <Checkbox>I've read and agreed to <Link to={'/terms-and-conditions'} target="_blank">Terms &amp; Conditions</Link></Checkbox>
                    </Form.Item>

                    <Form.Item name='price' hidden={true}>
                        <InputNumber />
                    </Form.Item>

                    <Form.Item name='days' hidden={true}>
                        <InputNumber />
                    </Form.Item>

                    <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.service !== currentValues.service}>
                        {({ getFieldValue }) => {
                            if (['fiction', 'thesis', 'blurb', 'review', 'dilemma'].includes(getFieldValue('service'))) {
                                return (
                                    <Form.Item
                                        name="upload"
                                        label="Literature to upload"
                                        valuePropName="fileList"
                                        getValueFromEvent={normFile}
                                        extra="Only a single .doc or .docx file is accepted. Word Track Change is used to provide a feedback."
                                        rules={[ {required: true}, ]}>
                                        <Upload name="file"
                                                action="/api/upload"
                                                listType="picture"
                                                maxCount={1}
                                                beforeUpload={file => {
                                                    let allowTypes = [
                                                        'application/msword',
                                                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                                    ];

                                                    if (!allowTypes.includes(file.type)) {
                                                        message.error(`${file.name} is not a document file`);
                                                    }

                                                    return allowTypes.includes(file.type) ? true : Upload.LIST_IGNORE;
                                                }}>
                                            <Button icon={<UploadOutlined />}>Click to upload</Button>
                                        </Upload>
                                    </Form.Item>
                                )
                            }

                            if (['audiobook'].includes(getFieldValue('service'))) {
                                return (
                                    <Form.Item
                                        name="upload"
                                        label="Audio and manuscript to upload"
                                        valuePropName="fileList"
                                        getValueFromEvent={normFile}
                                        extra=".mp3, m4a and .pdf files are accepted."
                                        rules={[ {required: true}, ]}>
                                        <Upload name="file"
                                                action="/api/upload"
                                                listType="picture"
                                                beforeUpload={file => {
                                                    let allowTypes = [
                                                        'application/msword',
                                                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                                        'audio/mpeg',
                                                        'audio/mp4a-latm',
                                                        'application/pdf',
                                                        'audio/x-wav'
                                                    ];

                                                    if (!allowTypes.includes(file.type)) {
                                                        message.error(`${file.name} is not a audio/document/pdf file`);
                                                    }

                                                    return allowTypes.includes(file.type) ? true : Upload.LIST_IGNORE;
                                                }}>
                                            <Button icon={<UploadOutlined />}>Click to upload</Button>
                                        </Upload>
                                    </Form.Item>
                                )
                            }

                            if (['narration'].includes(getFieldValue('service'))) {
                                return (
                                    <Form.Item
                                        name="upload"
                                        label="Manuscript to upload"
                                        valuePropName="fileList"
                                        getValueFromEvent={normFile}
                                        extra=".doc, .docx and .pdf files are accepted."
                                        rules={[ {required: true}, ]}>
                                        <Upload name="file"
                                                action="/api/upload"
                                                listType="picture"
                                                maxCount={1}
                                                beforeUpload={file => {
                                                    let allowTypes = [
                                                        'application/msword',
                                                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                                        'application/pdf',
                                                    ];

                                                    if (!allowTypes.includes(file.type)) {
                                                        message.error(`${file.name} is not a document/pdf file`);
                                                    }

                                                    return allowTypes.includes(file.type) ? true : Upload.LIST_IGNORE;
                                                }}>
                                            <Button icon={<UploadOutlined />}>Click to upload</Button>
                                        </Upload>
                                    </Form.Item>
                                )
                            }
                        }}
                    </Form.Item>

                    {/*<Form.Item name='coupon_code' label="Coupon Code"
                               extra="Enter coupon code here if you have one." onChange={updateCoupon} hasFeedback
                               validateStatus={!couponError ? couponCode ? validatingCode ? 'validating' :  'success': '': 'error'}
                            rules={[ {required: false}, ]}>
                        <Input  disabled={couponCode && !couponError ? 'disabled' : ''}/>
                    </Form.Item>*/}

                    { price > 0 && days ?
                        <Form.Item label={true}>
                            <Button type="primary" htmlType="submit">Proceed to pay &#163;{price} for estimated work of {days} working days</Button>
                        </Form.Item>
                    : <Form.Item label={true}>
                            <Button type="primary" htmlType="submit">Proceed to pay</Button>
                      </Form.Item>
                    }
                </Form>}
                {showFailed && <Result
                    status="warning"
                    title="There are some problems with submitting the request."
                    subTitle={'If this happens repeatably, let us know by the email to help you.'}
                />}
            </div>
        </div>
    )

}
